import axios from '../../config/axios.js'
import { addIso690 } from '../../custom/function'

const STATE = {

    nodes: [],
    edges: [],
    width: 0,
    height: 0,
    attr_node_size: 'in_degree',
    attr_node_color: 'doc_type',

    vertex_library: [],

    on_sg: false,
    sg_keys: [],
    node_documents: [],

    tree_mode: null,
    tree_base: null,

    documents: null,
    ranks: null,
    references: null,
    translations: null,
    collections: null,
    revisions: null,

    changing_tree: true,
}

const GETTERS = {

    tree_mode: state => state.tree_mode,
    tree_base: state => state.tree_base,

    nodes: state => state.nodes,
    edges: state => state.edges,
    width: state => state.width,
    height: state => state.height,
    attr_node_size: state => state.attr_node_size,
    attr_node_color: state => state.attr_node_color,

    vertex_library: state => state.vertex_library,

    on_sg: state => state.on_sg,
    sg_keys: state => state.sg_keys,
    node_documents: state => state.node_documents,

    documents: state => state.documents,
    ranks: state => state.ranks,
    references: state => state.references,
    translations: state => state.translations,
    collections: state => state.collections,
    revisions: state => state.revisions,

    changing_tree: state => state.changing_tree,

}

const MUTATIONS = {

    createTree(state, tree) {
        state.nodes = tree.nodes
        state.edges = tree.edges
        state.width = tree.frame.width
        state.height = tree.frame.height
    },

    setTreeMode(state, res) {
        state.tree_base = res.base
        state.tree_mode = res.mode
    },

    setVertexLibrary(state, library) {
        state.vertex_library = library
    },

    setSgKeys(state, sg_keys) {
        state.sg_keys = sg_keys
    },

    setOnSg(state, on_sg) {
        state.on_sg = on_sg
    },

    setNodeDocuments(state, documents) {
        state.node_documents = documents
    },

    getTreeData(state, res) {
        state.ranks = res.Ranks
        state.references = res.References
        state.translations = res.Translations
        state.collections = res.Collections
        state.revisions = res.Revisions
    },

    getTreeDocuments(state, documents) {
        state.documents = documents
    },

    changeTree(state, change) {
        state.changing_tree = change
    },

}

const ACTIONS = {

    async createGraph({ commit }, payload) {
        await axios.ACCESS.post('/api/graph/project/' + payload.proj_id, {
                depth: payload.depth,
                with_all_relationship: true,
                calculate_position: true,
                tree_type: 1,
            })
            .then(res => {
                // console.log('tree/createGraph', res)
                commit('createTree', res.data.data)
            })
    },

    async createMPGraph({ commit }, payload) {
        await axios.ACCESS.post('/api/tree/masterpiece/' + payload.mp_id, {
                depth: 2,
                with_all_relationship: false,
                calculate_position: true,
                tree_type: 1,
            })
            .then(res => {
                // console.log('tree/createMPGraph', res)
                commit('createTree', res.data.data)
            })
    },

    async getProjectTreeData({ commit }, payload) {
        await axios.ACCESS.post("/api/graphdata/project/" + parseInt(payload.project), {
                depth: 4,
                use_recursive_cte: false,
                with_all_relationship: true
            })
            .then(res => {
                // console.log("[VUEX]tree/getProjectTreeData", res)
                commit("getTreeData", res.data.data)
                addIso690(res.data.data.Documents)
                    .then(res => {
                        commit('getTreeDocuments', res)
                    })
            })
    },


    async getWatchingProjectTreeData({ commit }, payload) {
        await axios.ACCESS.post('/api/s2/graphdata/guestproject/' + parseInt(payload.project), {
                depth: 4,
                with_all_relationship: true
            })
            .then(res => {
                // console.log("[VUEX]tree/getWatchingProjectTreeData", res)
                commit("getTreeData", res.data.data)
                addIso690(res.data.data.Documents)
                    .then(res => {
                        commit('getTreeDocuments', res)
                    })
            })
    },

    async getDocsTreeData({ commit }, payload) {
        // payload { "documents": [dockey list], "depth: 5", "with_all_relationship": true }
        await axios.ACCESS.post("/api/graphdata/document", payload)
            .then(res => {
                // console.log("[VUEX]tree/getDocsTreeData", res)
                commit("getTreeData", res.data.data)
            })
    },
}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/tree.js